import { Address } from './address';

export class Customer {
    anniversaryDate: string;
    birthday: string;
    company: string;
    dietaryRequirement: string;
    email: string;
    firstName: string;
    gender: string;
    id: number;
    language: string;
    lastName: string;
    mobile: string;
    new: boolean;
    noOfKids: number;
    noOfPets: number;
    propertyId: number;
    roleName: string;
    address: Address;
}